// 导入组件，组件必须声明 name
import User from './User.vue'

// 为组件添加 install 方法，用于按需引入
User.install = function(Vue) {
	Vue.component(User.name, User)
}

export default User
